import { TFunction } from 'i18next';
import toast from 'react-hot-toast';

import ToastMessageBlock from '@/components/Toasts/SuccessToast';

/**
 * Show a success toast after assigning or updating assignments for team members.
 *
 * Toast message depends on the count of team members:
 * - If count is 0: "Assignment updated" (only auto-assign toggle changed)
 * - If count is 1: "You successfully assigned 1 Team Member to this plan."
 * - If count > 1: "You successfully assigned {count} Team Members to this plan."
 *
 * @param count The number of team members assigned
 * @param t The i18next translation function
 */
export const showAssignmentSuccessToast = (count: number, t: TFunction) => {
  const message =
    count === 0
      ? t('autoAssignToggle.assignmentUpdated')
      : count === 1
        ? t('TrainingPlans.toastMessage.assignedTeamMember')
        : t('TrainingPlans.toastMessage.assignedTeamMembers', { count });

  toast.custom(toastObj => (
    <ToastMessageBlock id={toastObj.id}>{message}</ToastMessageBlock>
  ));
};
